import * as React from 'react'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

export function ParityReportExecutionProvider({children}) {
	const urlParams = new URLSearchParams(window.location.search)
	const idFromUrl = urlParams.get('id_report_execution')
	if (idFromUrl) window.history.replaceState({}, '', window.location.pathname)

	const { state, updateState, resetState } = useAppContextState({
		idReportExecution: idFromUrl ? Number(idFromUrl) : null
	})

	return <Context.Provider value={{state, updateState, resetState}}>
		{children}
	</Context.Provider>
}

export default Context
